(() => {
  const setupDepartmentMenus = () => {
    document.querySelectorAll('.header-navigation__departments-panel').forEach((menu) => {
      const items = menu.querySelectorAll('[data-departments-target]');
      const panels = menu.querySelectorAll('[data-departments-panel]');

      const activate = (target) => {
        items.forEach((item) => item.classList.toggle('is-active', item.dataset.departmentsTarget === target));
        panels.forEach((panel) => {
          const active = panel.id === target;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('hidden', !active);
        });
      };

      items.forEach((item) => {
        item.addEventListener('mouseenter', () => activate(item.dataset.departmentsTarget));
        item.querySelector('a')?.addEventListener('focus', () => activate(item.dataset.departmentsTarget));
      });

      const firstItem = items[0];
      if (firstItem) activate(firstItem.dataset.departmentsTarget);
    });

    document.querySelectorAll('[data-mobile-menu-close]').forEach((closeButton) => {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        const drawerDetails = closeButton.closest('#Details-menu-drawer-container');
        drawerDetails?.querySelector(':scope > summary')?.click();
      });
    });

    const secondaryItems = document.querySelectorAll('.header-navigation__secondary-item.has-children');

    const alignSecondaryMenu = (item) => {
      item.classList.remove('is-aligned-right');
      if (window.innerWidth < 990) return;

      const panel = item.querySelector(':scope > .header-navigation__secondary-panel');
      if (!panel) return;

      const itemRect = item.getBoundingClientRect();
      const panelWidth = panel.getBoundingClientRect().width;
      const viewportGutter = 12;

      if (itemRect.left + panelWidth > window.innerWidth - viewportGutter) {
        item.classList.add('is-aligned-right');
      }
    };

    secondaryItems.forEach((item) => {
      item.addEventListener('mouseenter', () => alignSecondaryMenu(item));
      item.addEventListener('focusin', () => alignSecondaryMenu(item));
    });

    window.addEventListener('resize', () => {
      secondaryItems.forEach(alignSecondaryMenu);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupDepartmentMenus);
  else setupDepartmentMenus();
})();
